import React, { useState } from "react";

import { Dialog, DialogContent, DialogTitle, Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { QRCodeWrapper } from "./styles";
import {
	useLazyCreateOwnerInvitationQRCodeQuery,
	useLazyCreateOwnerMemoriesQRCodeQuery
} from "../../../store/services/invitations/invitations.service";
import { toast } from "react-toastify";
import { notifyError } from "../../../utils/NotifyError";
import { IError } from "../../../utils/getErrorMessage";
import { createQRPDFFromSignedUrl } from "../../../utils/createQRPdf";
import ButtonComponent from "../../ButtonComponent";
const ShareByQRModal = ({
	id,
	open,
	onClose,
	qr_url,
	invitation_url
}: {
	id: string;
	open: boolean;
	onClose: () => void;
	qr_url: string;
	invitation_url?: boolean;
}) => {
	const [callGenerateQRCode, { isLoading: isCreatingQRCode }] = useLazyCreateOwnerMemoriesQRCodeQuery();
	const [callGenerateInvitationQRCode, { isLoading: isCreatingInvitationQRCode }] =
		useLazyCreateOwnerInvitationQRCodeQuery();
	const [generatedUrl, setGeneratedUrl] = useState("");
	const [QRLoaded, setQRLoaded] = useState(false);
	const [isCreatingQRFromUrl, setIsCreatingQRFromUrl] = useState(false);
	const handleGenerateQRCode = () => {
		if (invitation_url) {
			return callGenerateInvitationQRCode({ id }).then(({ data, error }) => {
				if (data) {
					toast.success("QR Code has been generated successfully.", { autoClose: 3000 });
					setGeneratedUrl(data.url);
				}
				if (error) {
					notifyError(error as IError);
				}
			});
		}
		callGenerateQRCode({ id }).then(({ data, error }) => {
			if (data) {
				toast.success("QR Code has been generated successfully.", { autoClose: 3000 });
				setGeneratedUrl(data.url);
			}
			if (error) {
				notifyError(error as IError);
			}
		});
	};

	const handleOnPrint = async () => {
		setIsCreatingQRFromUrl(true);
		const pdf = await createQRPDFFromSignedUrl(qr_url || generatedUrl);

		const blobUrl = pdf.output("bloburl");
		window.open(blobUrl, "_blank");
		setIsCreatingQRFromUrl(false);
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={"xs"}
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">Share QR Code</DialogTitle>
			<Box display="flex" justifyContent="flex-end" style={{ position: "absolute", right: "20px", top: "20px" }}>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</Box>
			<DialogContent>
				<QRCodeWrapper mt={2}>
					{qr_url || generatedUrl ? (
						<Box
							display={"flex"}
							flexDirection={"column"}
							justifyContent={"center"}
							alignItems={"center"}
							height={"35vh"}
						>
							<img src={qr_url || generatedUrl} width={280} alt="Memories QR Code" onLoad={() => setQRLoaded(true)} />
							{QRLoaded && (
								<ButtonComponent
									fullWidth
									variant={"contained"}
									onClick={handleOnPrint}
									disabled={isCreatingQRFromUrl}
									loading={isCreatingQRFromUrl}
									text={"Print"}
								/>
							)}
						</Box>
					) : (
						<Box width={"100%"} display={"flex"} justifyContent={"center"}>
							<ButtonComponent
								variant={"contained"}
								onClick={handleGenerateQRCode}
								loading={isCreatingQRCode || isCreatingInvitationQRCode}
								disabled={isCreatingQRCode || isCreatingInvitationQRCode}
								text={"Generate QR Code"}
							/>
						</Box>
					)}
				</QRCodeWrapper>
			</DialogContent>
		</Dialog>
	);
};

export default ShareByQRModal;
